'use es6';
/**
 * Copied from com.hubspot.model.index.CosIndexObjectType
 */

export const BLOG = 'BLOG';
export const CONTENT = 'CONTENT';
export const CUSTOM_WIDGET = 'CUSTOM_WIDGET';
export const DOMAIN = 'DOMAIN';
export const EMAIL_ADDRESS = 'EMAIL_ADDRESS';
export const EXTENSION_RESOURCE = 'EXTENSION_RESOURCE';
export const FOLDER = 'FOLDER';
export const FORM = 'FORM';
export const GLOBAL_CONTENT = 'GLOBAL_CONTENT';
export const GLOBAL_CONTENT_PARTIAL = 'GLOBAL_CONTENT_PARTIAL';
export const IMAGE = 'IMAGE';
export const LAYOUT = 'LAYOUT';
export const PLACEMENT = 'PLACEMENT';
export const SITE_SETTINGS = 'SITE_SETTINGS';
export const WIDGET = 'WIDGET';
export const WORKFLOW = 'WORKFLOW';
export const RAW_ASSET = 'RAW_ASSET';
/**
 * Dependents with a type of QUOTE_TEMPLATE refer to quote template CRM objects
 * in the sales settings. We'll refer to them as SALES_QUOTE_TEMPLATE dependents
 * in the design manager code because the term "quote templates" should be
 * reserved for quote-type CMS templates (which are returned with a type of
 * EXTENSION_RESOURCE when fetching dependents)
 * */

export const QUOTE_TEMPLATE = 'QUOTE_TEMPLATE';